export const initialBudgetModalState = {
  recipient: '',
  amount: '',
  currency: '',
  product: '',
  commission: '0',
  commissionCurrency: '',
  exchangeRate: '',
  comment: '',
  dateTime: '',
  walletId: '',
  budgetItemId: '',
  id: '',
}
